var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      class: _vm.$vuetify.theme.dark
        ? "theme_dark theme_dark_border"
        : "theme_light theme_light_border",
      attrs: {
        id: "navId",
        permanent: true,
        width: _vm.navBarWidth,
        "mini-variant-width": _vm.miniNavBarWidth,
        clipped: _vm.$vuetify.breakpoint.lgAndUp,
        "mini-variant": _vm.miniDrawer,
        fixed: "",
        app: _vm.$vuetify.breakpoint.lgAndUp,
      },
      on: {
        "update:miniVariant": function ($event) {
          _vm.miniDrawer = $event
        },
        "update:mini-variant": function ($event) {
          _vm.miniDrawer = $event
        },
      },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "v-list",
        {
          class:
            _vm.miniDrawer === true
              ? "drawer-menu-list__mini"
              : "drawer-menu-list__full",
          attrs: { dense: "" },
        },
        [
          _vm._l(_vm.items, function (item) {
            return [
              _c(
                "v-tooltip",
                {
                  key: item.text,
                  attrs: { right: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            item.children
                              ? _c(
                                  "v-list-group",
                                  {
                                    key: item.text,
                                    staticClass: "drawer-menu-list-group",
                                    class: { minified: _vm.miniDrawer },
                                    attrs: {
                                      "append-icon": "",
                                      id: "menuListGroup",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prependIcon",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    "mt-1":
                                                      _vm.$vuetify.breakpoint
                                                        .mdAndDown,
                                                  },
                                                  staticStyle: {
                                                    width: "100%",
                                                    display: "flex",
                                                    "justify-content": "center",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "drawer-menu-list-group__icon",
                                                      class: _vm.$vuetify.theme
                                                        .dark
                                                        ? item.model
                                                          ? "iconColorClicked_dark"
                                                          : "iconColorNotClicked_dark"
                                                        : item.model
                                                        ? "iconColorClicked_light"
                                                        : "iconColorClicked_dark",
                                                      staticStyle: {
                                                        "margin-top":
                                                          "8px !important",
                                                      },
                                                      style: _vm.miniDrawer
                                                        ? `font-size: ${item.fontSize}px;`
                                                        : `font-size: ${item.fontSize}px;`,
                                                      attrs: { medium: "" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.icon) + " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "activator",
                                          fn: function () {
                                            return [
                                              !_vm.miniDrawer
                                                ? _c("hr", {
                                                    staticStyle: {
                                                      "margin-right": "6px",
                                                      height: "20px",
                                                    },
                                                    attrs: {
                                                      width: "1",
                                                      color: _vm.$vuetify.theme
                                                        .dark
                                                        ? "white"
                                                        : "primary",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "v-list-item",
                                                {
                                                  class: _vm.$vuetify.theme.dark
                                                    ? "drawer-menu-list-group-sub-item iconColor_dark"
                                                    : "drawer-menu-list-group-sub-item iconColor_light",
                                                  staticStyle: {
                                                    height: "50px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          class:
                                                            _vm.getItemClass(
                                                              "text",
                                                              item.clicked
                                                            ) + " menu_text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.text) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: item.model,
                                      callback: function ($$v) {
                                        _vm.$set(item, "model", $$v)
                                      },
                                      expression: "item.model",
                                    },
                                  },
                                  _vm._l(item.children, function (child, i) {
                                    return _c(
                                      "div",
                                      { key: i },
                                      [
                                        (
                                          child.text === "Debugger"
                                            ? !!_vm.isAdmin
                                            : true
                                        )
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                key: item.text,
                                                attrs: { right: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c("v-hover", {
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    hover,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-list-item",
                                                                        _vm._g(
                                                                          {
                                                                            class:
                                                                              _vm
                                                                                .$vuetify
                                                                                .theme
                                                                                .dark &&
                                                                              child.clicked
                                                                                ? "drawer-menu-list-item clicked_item_background_dark"
                                                                                : child.clicked
                                                                                ? "drawer-menu-list-item clicked_item_background_light"
                                                                                : "drawer-menu-list-item",
                                                                            style:
                                                                              {
                                                                                height:
                                                                                  "50px",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.enterPage(
                                                                                    child
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          _vm.miniDrawer &&
                                                                            !_vm.isMobileOrTablet
                                                                            ? on
                                                                            : 0
                                                                        ),
                                                                        [
                                                                          child.icon
                                                                            ? _c(
                                                                                "v-list-item-action",
                                                                                {
                                                                                  staticClass:
                                                                                    "drawer-menu-list-group-sub-item-action",
                                                                                },
                                                                                [
                                                                                  child.text !==
                                                                                  "About"
                                                                                    ? _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          class:
                                                                                            _vm.getItemClass(
                                                                                              "icon",
                                                                                              child.clicked
                                                                                            ),
                                                                                          style:
                                                                                            _vm.miniDrawer
                                                                                              ? `font-size: ${child.fontSize}px;`
                                                                                              : `font-size: ${child.fontSize}px;`,
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              child.icon
                                                                                            ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm
                                                                                        .$vuetify
                                                                                        .theme
                                                                                        .dark
                                                                                    ? _c(
                                                                                        "v-img",
                                                                                        {
                                                                                          style:
                                                                                            _vm.miniDrawer
                                                                                              ? `font-size: ${child.fontSize}px;`
                                                                                              : `font-size: ${child.fontSize}px;`,
                                                                                          attrs:
                                                                                            {
                                                                                              height:
                                                                                                "21",
                                                                                              contain:
                                                                                                "",
                                                                                              src: "/img/dynamic-src-images/icons/about-dark-13x20.svg",
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _c(
                                                                                        "v-img",
                                                                                        {
                                                                                          style:
                                                                                            _vm.miniDrawer
                                                                                              ? `font-size: ${child.fontSize}px;`
                                                                                              : `font-size: ${child.fontSize}px;`,
                                                                                          attrs:
                                                                                            {
                                                                                              height:
                                                                                                "21",
                                                                                              contain:
                                                                                                "",
                                                                                              src: "/img/dynamic-src-images/icons/about-13x20.svg",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          _c(
                                                                            "v-list-item-action",
                                                                            {
                                                                              class:
                                                                                _vm.miniDrawer
                                                                                  ? "drawer-menu-list-item-action__mini"
                                                                                  : "drawer-menu-list-item-action",
                                                                            },
                                                                            [
                                                                              !_vm.miniDrawer
                                                                                ? _c(
                                                                                    "hr",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          height:
                                                                                            "20px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          width:
                                                                                            "1",
                                                                                          color:
                                                                                            _vm
                                                                                              .$vuetify
                                                                                              .theme
                                                                                              .dark
                                                                                              ? child.clicked
                                                                                                ? "primary"
                                                                                                : "white"
                                                                                              : "primary",
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  class:
                                                                                    _vm.getItemClass(
                                                                                      "text",
                                                                                      child.clicked
                                                                                    ) +
                                                                                    " menu_text",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          "margin-left":
                                                                                            "0 !important",
                                                                                          "margin-right":
                                                                                            "0 !important",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              child.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      child.external
                                                                                        ? _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              staticStyle:
                                                                                                {
                                                                                                  "font-size":
                                                                                                    "10px !important",
                                                                                                  "margin-left":
                                                                                                    "8px !important",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  dark: hover,
                                                                                                  src: child.link,
                                                                                                  "max-width":
                                                                                                    "33",
                                                                                                  "x-small":
                                                                                                    "",
                                                                                                  color:
                                                                                                    hover
                                                                                                      ? "rgb(128,128,128,0.8)"
                                                                                                      : "rgb(128,128,128,0)",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "fas fa-external-link-alt "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: child.hovered,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      child,
                                                      "hovered",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "child.hovered",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(child.text)),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              : _c("v-hover", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ hover }) {
                                          return [
                                            _c(
                                              "v-list-item",
                                              _vm._g(
                                                {
                                                  key: item.text,
                                                  class:
                                                    _vm.$vuetify.theme.dark &&
                                                    (item.clicked ||
                                                      _vm.currentPagePath ===
                                                        item.link)
                                                      ? "clicked_item_background_dark textColor_dark"
                                                      : item.clicked ||
                                                        _vm.currentPagePath ===
                                                          item.link
                                                      ? "clicked_item_background_light textColor_light"
                                                      : "",
                                                  staticStyle: {
                                                    height: "50px",
                                                  },
                                                  style:
                                                    _vm.$vuetify.breakpoint
                                                      .height < 630
                                                      ? "height: 40px !important;"
                                                      : "opacity:1; !important;",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.enterPage(item)
                                                    },
                                                  },
                                                },
                                                _vm.miniDrawer &&
                                                  !_vm.isMobileOrTablet
                                                  ? on
                                                  : 0
                                              ),
                                              [
                                                _c(
                                                  "v-list-item-action",
                                                  {
                                                    class: _vm.miniDrawer
                                                      ? "drawer-menu-list-item-action__mini"
                                                      : "drawer-menu-list-item-action",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        class: _vm.getItemClass(
                                                          "icon",
                                                          item.clicked
                                                        ),
                                                        style:
                                                          "font-size: " +
                                                          item.fontSize +
                                                          "px;",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.icon) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("v-list-item-action", [
                                                  !_vm.miniDrawer
                                                    ? _c("hr", {
                                                        class: `menu_item_bar ${
                                                          _vm.miniDrawer
                                                            ? "drawer-menu-list-item-action__mini"
                                                            : "drawer-menu-list-item-action"
                                                        }`,
                                                        staticStyle: {
                                                          height: "20px",
                                                        },
                                                        attrs: {
                                                          width: "1",
                                                          color: _vm.$vuetify
                                                            .theme.dark
                                                            ? item.clicked
                                                              ? "primary"
                                                              : "white"
                                                            : "primary",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]),
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        class:
                                                          _vm.getItemClass(
                                                            "text",
                                                            item.clicked
                                                          ) + " menu_text",
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "0 !important",
                                                              "margin-right":
                                                                "0 !important",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.text
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            item.external
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "10px !important",
                                                                        "margin-left":
                                                                          "8px !important",
                                                                      },
                                                                    attrs: {
                                                                      dark: hover,
                                                                      src: item.link,
                                                                      "max-width":
                                                                        "33",
                                                                      "x-small":
                                                                        "",
                                                                      color:
                                                                        hover
                                                                          ? "rgb(128,128,128,0.8)"
                                                                          : "rgb(128,128,128,0)",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "fas fa-external-link-alt "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                item.text === "Price Watcher"
                                                  ? _c("v-img", {
                                                      staticStyle: {
                                                        position: "absolute",
                                                        right: "13px",
                                                        bottom: "19px",
                                                      },
                                                      attrs: {
                                                        dark: "",
                                                        "max-width": "33",
                                                        src: require("../assets/other-images/beta.png"),
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [_c("span", [_vm._v(_vm._s(item.text))])]
              ),
            ]
          }),
        ],
        2
      ),
      !_vm.miniDrawer
        ? _c(
            "v-container",
            {
              staticClass: "pl-1 pb-0",
              class: _vm.$vuetify.breakpoint.lgAndUp
                ? "bPadding4RightsM10"
                : "bPadding4RightsM20",
              staticStyle: {
                position: "fixed !important",
                "text-align": "center",
                color: "#1c6e59",
              },
              style: !_vm.getMiniDrawer
                ? "opacity: 0"
                : "opacity: 1; transition: opacity 1s",
            },
            [
              _c(
                "p",
                {
                  staticClass: "rightsText",
                  class: {
                    "mb-0":
                      _vm.$vuetify.breakpoint.height <
                        _vm.$vuetify.breakpoint.width &&
                      _vm.$vuetify.breakpoint.height < 500,
                  },
                },
                [
                  _vm._v(" ©" + _vm._s(_vm.currentYear) + " "),
                  _c(
                    "a",
                    {
                      staticClass: "hover-text-primary",
                      staticStyle: { color: "#1c6e59" },
                      attrs: { href: "http://dealio.ai", target: "_blank" },
                    },
                    [_vm._v("Dealio")]
                  ),
                  _vm._v(" v" + _vm._s(_vm.appVersion) + " "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }